import React, { useEffect, useState } from 'react';
import Dropdown, { Item } from 'components/common/Dropdown';
import { ReactComponent as Delete } from 'style/imgs/icons/delete-icon.svg';
import { Resource } from 'types';
import resourceTypes from 'utils/helpers/resourcesMap';
import styles from './styles.module.scss';

interface Props {
  resource: Resource;
  onDelete(id: number): void;
  onChange(id: number, value: string): void;
  onCategoryChange(id: number, category: string): void;
}

const categories: Item[] = resourceTypes.map((rt, i) => ({
  id: i,
  label: rt.label,
}));

const ResourceListItem = React.forwardRef<HTMLInputElement, Props>(
  ({ resource, onDelete, onChange, onCategoryChange }, ref) => {
    const { link, type, id } = resource;

    const [readOnly, setReadOnly] = useState(true);

    const [inputValue, setInputValue] = useState(link);
    useEffect(() => {
      setInputValue(link);
    }, [link]);

    const handleFocus = () => {
      setReadOnly(false);
    };

    const handleBlur = () => {
      setReadOnly(true);
      onChange(id, inputValue);
    };

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = ({
      target: { value },
    }) => {
      setInputValue(value.trim());
    };

    const handleCategoryChange = (c: Item<number>) => {
      const cat = resourceTypes[c.id]?.id;
      onCategoryChange(id, cat);
    };

    const categoryIndex = resourceTypes.findIndex((l) => l.id === type);
    const value: Item = {
      id: categoryIndex,
      label: resourceTypes[categoryIndex]?.label,
    };

    const editable = resource?.ownerType !== 'event';

    return (
      <li className={styles.root}>
        <div
          className={`${styles.urlContainer} ${
            resource.isNewItem ? styles.newItem : ''
          }`}
        >
          <input
            ref={ref}
            type="text"
            className={styles.url}
            value={inputValue || ''}
            placeholder="Insert new URL"
            readOnly={readOnly}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            disabled={!editable}
          />
          {editable && (
            <button
              className={styles.delete}
              type="button"
              onClick={() => onDelete(id)}
            >
              <Delete />
            </button>
          )}
        </div>
        <Dropdown
          items={categories}
          value={value}
          onChange={handleCategoryChange}
          disabled={!editable}
        />
      </li>
    );
  }
);

export default ResourceListItem;
